import ImageComponent from "@/components/ui/ImageComponent"

interface ITreatmentDetailCardProps{
    image_url:string,
    heading:string,
    description:string,
    listItems:string[]
}

const TreatmentDetailCard = ({image_url,heading,description,listItems}:ITreatmentDetailCardProps) => {
  return (
    <div className="flex justify-center mx-auto flex-wrap md:flex-nowrap gap-y-10">
        <div className="w-full md:max-w-[451px] rounded-3xl overflow-hidden">
            <div className="h-auto">
                <ImageComponent url={image_url||"/images/home_data/banner_1.png"} img_title={heading || "treatment_phases"}/>
            </div>
        </div>
        <div className="w-full md:w-fit pl-0 md:pl-[25px]">
            <div className="space-y-5">
                <h2 className="heading_text">{heading}</h2>
                <div className="space-y-3 text-textf1 text-base/[25.6px] font-normal">
                    <p>{description}</p>
                    <ul className="space-y-3 list-disc ml-3">
                        {listItems?.map((curr,index)=>(<li key={`treatmeant_data_${index+1}`}>{curr}</li>))}
                    </ul>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TreatmentDetailCard